import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import s from './Input.module.css';
export const Input = forwardRef(function Input({ mono = false, className, ...rest }, ref) {
    return (_jsx("input", { ref: ref, ...rest, className: [s.input, mono && s.mono, className].filter(Boolean).join(' ') }));
});
